<template>
  <div>
    <el-alert
      :title="config.failedMsg"
      type="error"
      show-icon
      v-if="!!config.failedMsg"
      style="margin-bottom: 20px;"
    ></el-alert>

    <el-card v-if="this.config.isLoadingOrderInfo">
      <el-tag type="info">{{$t('guestID.loadingOrder')}} &nbsp;&nbsp;<i class="el-icon-loading"></i></el-tag>
    </el-card>

    <div
      class="verify-desc"
      v-if="!this.config.isLoadingOrderInfo"
    >
      <span v-html="$t('guestID.verifyDesc')"></span>
    </div>

    <el-tabs
      class="vertify-tabs"
      v-if="!this.config.isLoadingOrderInfo"
      value="orderNo"
      tab-position="top"
      type="border-card"
    >
      <el-tab-pane
        class="order-panel"
        :label="$t('guestID.verifyOrder.header')"
        name="orderNo"
        style="padding: 10px 0px 20px;"
      >
        <div class="vertify-content">
          <div class="fillDesc">{{$t('guestID.verifyOrder.tip')}}</div>
          <div
            v-for="(order, index) in tpls.orders"
            :key="index"
            class="fillBox"
          >
            <span>{{order.tpl}}</span>
            <el-input
              size="medium"
              :placeholder="$t('guestID.verifyLast4chars')"
              v-model="order.value"
              style="max-width: 165px;"
              :maxlength="4"
            >
              <el-button
                class="verify-btn"
                slot="append"
                icon="el-icon-check"
                @click="verify('CONFIRM_NO', order)"
              ></el-button>
            </el-input>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane
        class="order-panel"
        :label="$t('guestID.verifyPhone.header')"
        name="phone"
        style="padding: 10px 0px 20px;"
        v-if="vertifyTypeMap['PHONE']"
      >
        <div class="vertify-content">
          <div class="fillDesc">{{$t('guestID.verifyPhone.tip')}}</div>
          <div
            v-for="(phone, index) in tpls.phones"
            :key="index"
            class="fillBox"
          >
            <span>{{phone.tpl}}</span>
            <el-input
              size="medium"
              :placeholder="$t('guestID.verifyLast4chars')"
              v-model="phone.value"
              style="max-width: 165px;"
              :maxlength="4"
            >
              <el-button
                class="verify-btn"
                slot="append"
                icon="el-icon-check"
                @click="verify('PHONE', phone)"
              ></el-button>
            </el-input>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane
        class="order-panel"
        :label="$t('guestID.verifyEmail.header')"
        name="email"
        style="padding: 10px 0px 20px;"
        v-if="vertifyTypeMap['EMAIL']"
      >
        <div class="vertify-content">
          <div class="fillDesc">{{$t('guestID.verifyEmail.tip')}}</div>
          <div
            v-for="(email,idx) in tpls.emails"
            :key="idx"
            class="fillBox"
          >
            <span>{{email.tpl}}</span>
            <el-input
              size="medium"
              :placeholder="$t('guestID.verifyLast4chars')"
              v-model="email.value"
              style="max-width: 165px;"
              :maxlength="4"
            >
              <el-button
                class="verify-btn"
                slot="append"
                icon="el-icon-check"
                @click="verify('EMAIL', email)"
              ></el-button>
            </el-input>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  vertifyInfo,
  authenticate,
} from '@/api/identification'

export default {
  name: 'Verify',
  props: {
    openOrderId: String,
  },
  data () {
    return {
      config: {
        failedMsg: null,
        isLoadingOrderInfo: true,
      },
      tpls: {
        orders: [],
        phones: [],
        emails: [],
      },
      vertifyTypeMap: { // 用来检查用户的手机号或者邮箱是否存在，有的话就显示对应的校验框
        CONFIRM_NO: '',
        PHONE: '',
        EMAIL: '',
      },
    }
  },
  methods: {
    // 验证
    verify (type, tpl) {
      if (tpl.value === null || tpl.value === undefined) {
        this.$message.warning('Please enter at least one validation item')
        return
      }
      authenticate({
        openId: this.openOrderId, type, value: tpl.tpl.replace('****', tpl.value),
      }).then(res => {
        if (res.errCode === '200') {
          this.$cookie.setCustomerInfo(res.data || {})
          // 验证模块通过，通知上层进入下个步骤
          this.$emit('verifySuccess', true)
        } else {
          this.$message.error(res.errMsg)
        }
      }).catch(() => {})
    },
  },
  created () {
    // 请求验证信息
    vertifyInfo({
      openId: this.openOrderId,
    }).then(res => {
      if (res.errCode === '200') {
        const result = (res.data && res.data.datas) || []
        const orders = []
        const phones = []
        const emails = []
        if (result.length) {
          result.forEach(item => {
            this.vertifyTypeMap[item.type] = item.type
            if (item.type === 'CONFIRM_NO') {
              orders.push({ tpl: item.value, value: null })
            }
            if (item.type === 'PHONE') {
              phones.push({ tpl: item.value, value: null })
            }
            if (item.type === 'EMAIL') {
              emails.push({ tpl: item.value, value: null })
            }
          })
        }
        this.tpls.phones = phones
        this.tpls.emails = emails
        this.tpls.orders = orders
        this.config.isLoadingOrderInfo = false
      } else {
        this.$message.error(res.errMsg)
        this.config.failedMsg = res.errMsg
        this.config.isLoadingOrderInfo = true
      }
    }).catch(() => {
      this.config.isLoadingOrderInfo = true
      this.$emit('verifySuccess', false)
    })
  },
}
</script>

<style scoped lang="scss">
.fillDesc {
  line-height: 32px;
  color: #909399;
  font-size: 14px;
}

.fillBox span {
  margin: 0px 10px 0px 0px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  font-size: 14px;
}
.vertify-tabs {
  margin-bottom: 20px;
  // /deep/.el-tabs__header {
  //   width: auto;
  //   padding-left: 10px;
  // }
}
.vertify-content {
  display: flex;
  flex-direction: column;
  .fillBox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    /deep/.el-input {
      input {
        padding: 0 5px;
      }
    }
    /deep/.verify-btn {
      padding: 0 18px;
    }
  }
}
.verify-desc {
  line-height: 25px;
  padding: 0px 10px 10px 10px;
  color: $--color-danger;
  font-size: 14px;
  vertical-align: middle;
  white-space: normal;
}
</style>
